import React from 'react';
import { nanoid } from 'nanoid';

//Estilos
import './Table.css';
import './TableMediaQueries.css';

function Table({ tableData, functions, currentPage, pages }) {
    const { headers, title, pagination } = tableData;
    const { nextPage, previousPage, changePage, getPaginatedData } = functions;

    return (
        <div className="table-container">
            {title && <h4 className="table-title">{title}</h4>}
            <table className="table">
                <thead className="table-header">
                    <tr className="table-header-tr">
                        {headers.map((header, i) => {
                            return <th key={`th${nanoid()}`}>{header}</th>;
                        })}
                    </tr>
                </thead>
                <tbody className="table-body">
                    {getPaginatedData().map((info) => {
                        return (
                            <tr
                                key={`itemTable${nanoid()}`}
                                className="table-body-tr"
                            >
                                {Object.entries(info).map((infoData) => {
                                    return (
                                        <td
                                            key={`td${nanoid()}`}
                                            className="table-td"
                                            data-col={infoData[0]}
                                            data-title={
                                                headers[
                                                    Object.keys(info).indexOf(
                                                        infoData[0]
                                                    )
                                                ]
                                            }
                                        >
                                            {infoData[1]}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {pagination && pages > 1 && (
                <div className="table-footer">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={previousPage}
                    >
                        {'<'}
                    </button>{' '}
                    Página{' '}
                    <input
                        className="table-pagination_input"
                        type="number"
                        value={currentPage}
                        onChange={changePage}
                    />{' '}
                    de {pages}{' '}
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={nextPage}
                    >
                        {'>'}
                    </button>
                </div>
            )}
        </div>
    );
}

export default Table;
